/** Header / Canlı TV ile aynı anten (broadcast) ikonu */
export function LiveBeaconIcon({ className = '' }: { className?: string }) {
  return (
    <span className={`live-beacon ${className}`.trim()} aria-hidden>
      <svg className="live-beacon-svg" viewBox="0 0 22 14" fill="none">
        <path className="live-ring live-ring--2" d="M5.2 2.4C2.6 4.4 2.6 9.6 5.2 11.6" />
        <path className="live-ring live-ring--1" d="M7.4 4.3C6 5.5 6 8.5 7.4 9.7" />
        <circle className="live-core-pulse" cx="11" cy="7" r="2.6" />
        <circle className="live-core" cx="11" cy="7" r="1.55" fill="currentColor" />
        <path className="live-ring live-ring--1" d="M14.6 4.3C16 5.5 16 8.5 14.6 9.7" />
        <path className="live-ring live-ring--2" d="M16.8 2.4C19.4 4.4 19.4 9.6 16.8 11.6" />
      </svg>
    </span>
  )
}

export function isLiveNews(value: { live?: number | null | string } | null | undefined): boolean {
  return Number(value?.live ?? 0) === 1
}

type LiveBadgeProps = {
  /** pill: kırmızı arka plan | overlay: görsel üstü | inline: başlık yanı */
  variant?: 'pill' | 'overlay' | 'inline'
  className?: string
  label?: string
}

export default function LiveBadge({
  variant = 'pill',
  className = '',
  label = 'CANLI',
}: LiveBadgeProps) {
  return (
    <span
      className={['live-badge', `live-badge--${variant}`, className].filter(Boolean).join(' ')}
      title="Canlı haber"
    >
      <LiveBeaconIcon />
      <span className="live-badge__text">{label}</span>
    </span>
  )
}
